import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import Modal from 'react-modal';
import TagManager from "react-gtm-module";

const GA_MEASUREMENT_ID = process.env.REACT_APP_FIREBASE_MEASUREMENT_ID;
const tagManagerArgs = { gtmId: "GTM-NKJS2H5T" };

// Initialize dataLayer/gtag before GTM loads and default consent to denied
window.dataLayer = window.dataLayer || [];
if (GA_MEASUREMENT_ID) {
  window[`ga-disable-${GA_MEASUREMENT_ID}`] = true;
}
window.gtag = window.gtag || function () { window.dataLayer.push(arguments); };
window.gtag('consent', 'default', {
  ad_storage: 'denied',
  analytics_storage: 'denied',
  personalization_storage: 'denied'
});

TagManager.initialize(tagManagerArgs);

Modal.setAppElement('#root');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
